<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'
import { useAppUserStore } from '@/stores/appUser'

const { t } = useI18n()
const uiStore = useUiStore()
const appUserStore = useAppUserStore()

const currentIwr = computed(() => {
  return appUserStore.currentHealthGroupMembership.instituteWithRole
})

function setCreatorFilter(newFilter) {
  uiStore.setCreatorFilter(newFilter)
}
</script>

<template>
  <div class="bg-modal w-full" @click.stop>
    <div class="col gap-15">
    
      <!-- Creator filters -->
      <div>
        <text-item :txt="t('patient.filters.users')" styles="font-mBold" class="pad-m"/>
        <div class="rowcenter gap-02 mtop-02">
          <switchGroup styles="padButton-s" :active="uiStore.creatorFilter === 'AppUser'" @click="setCreatorFilter('AppUser')">
            <text-item :txt="t('patient.filters.myConsultations')" :class="uiStore.creatorFilter === 'AppUser' ? 'txt-white' : ''"/>
          </switchGroup>
          <switchGroup styles="padButton-s" :active="uiStore.creatorFilter === 'AppUserHealthProType'" @click="setCreatorFilter('AppUserHealthProType')">
            <text-item :txt="appUserStore.currentHealthGroupMembership.pwr.healthProType" :class="uiStore.creatorFilter === 'AppUserHealthProType' ? 'txt-white' : ''"/>
          </switchGroup>
          <switchGroup styles="padButton-s" :active="uiStore.creatorFilter === 'AppUserInstitute'" @click="setCreatorFilter('AppUserInstitute')">
            <text-item :txt="currentIwr.instituteShortName" :class="uiStore.creatorFilter === 'AppUserInstitute' ? 'txt-white' : ''"/>
          </switchGroup>
        </div>
      </div>

    </div>
  </div>
</template>